import { fb } from './firebase.js';
import { session } from './state.js';

const { db, doc, collection } = fb;

const fid = () => session.familyId;
const hid = (id) => id || session.selectedHeroId;

// Family-level
export const metaRef = () => doc(db, 'families', fid());
export const heroesCol = () => collection(db, 'families', fid(), 'heroes');
export const habitsCol = () => collection(db, 'families', fid(), 'habits');
export const rewardsCol = () => collection(db, 'families', fid(), 'rewards');
export const approvalsCol = () => collection(db, 'families', fid(), 'approvals');
export const maestrosCol = () => collection(db, 'families', fid(), 'maestros');
export const calendarCol = () => collection(db, 'families', fid(), 'calendar_events');
export const alertsCol = () => collection(db, 'families', fid(), 'alert_logs');
export const maestroNotifCol = () => collection(db, 'families', fid(), 'maestro_notifications');
export const fcmTokensCol = () => collection(db, 'families', fid(), 'fcm_tokens');
export const packsCol = () => collection(db, 'families', fid(), 'pending_missions');
export const discProfilesCol = () => collection(db, 'families', fid(), 'disc_profiles');

// Hero-level (nested)
export const heroRef = (id) => doc(db, 'families', fid(), 'heroes', hid(id));
export const dailyRef = (date, id) => doc(db, 'families', fid(), 'heroes', hid(id), 'daily', date);
export const dailyCol = (id) => collection(db, 'families', fid(), 'heroes', hid(id), 'daily');
export const pulseCol = (id) => collection(db, 'families', fid(), 'heroes', hid(id), 'pulse');
export const historyCol = (id) => collection(db, 'families', fid(), 'heroes', hid(id), 'history');
export const notificationsCol = (id) => collection(db, 'families', fid(), 'heroes', hid(id), 'notifications');
export const aiInsightsCol = (id) => collection(db, 'families', fid(), 'heroes', hid(id), 'ai_insights');
export const wellnessSignalsCol = (id) => collection(db, 'families', fid(), 'heroes', hid(id), 'wellnessSignals');
export const wellnessAlertsCol = () => collection(db, 'families', fid(), 'wellnessAlerts');

// Global (top-level)
export const userProfileRef = (uid) => doc(db, 'user_profiles', uid || session.uid);
export const invitationRef = (code) => doc(db, 'invitations', code.toUpperCase());

// Catalog (top-level) — FASE 3
export const professionalsCol = () => collection(db, 'professionals');
export const professionalRef = (id) => doc(db, 'professionals', id);
export const professionalApplicationsCol = () => collection(db, 'professional_applications');
export const professionalLeadsCol = () => collection(db, 'professional_leads');
